import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import type { Conversation, ConversationMenuItem } from '../types/chat.types';
import type { DeveloperPortalSupportAgentApi } from './DeveloperPortalSupportAgentApi';

export class DeveloperPortalSupportAgentClient
  implements DeveloperPortalSupportAgentApi
{
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  private async baseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('developer-portal-support-agent');
  }

  async listConversations(): Promise<ConversationMenuItem[]> {
    const response = await this.fetchApi.fetch(
      `${await this.baseUrl()}/conversations`,
      {
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `Failed to load conversation history: ${response.status} ${response.statusText}`,
      );
    }

    const data = (await response.json()) as ConversationMenuItem[];
    return Array.isArray(data) ? data : [];
  }

  async getConversation(conversationId: string): Promise<Conversation> {
    const response = await this.fetchApi.fetch(
      `${await this.baseUrl()}/conversations/${encodeURIComponent(
        conversationId,
      )}`,
      {
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `Failed to load conversation: ${response.status} ${response.statusText}`,
      );
    }

    const data = (await response.json()) as Conversation;

    if (!data) {
      throw new Error('Conversation response did not include a conversation');
    }

    return data;
  }
}
